import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import ReligionForm from '../components/forms/ReligionForm';
import '../styles/EmployeeMaster.css';
import ReligionTable from '../components/ReligionTable';

const ReligionEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams(); // ✅ Get ID from route

     const [religionData, setReligionData] = useState(null);
     const [loading, setLoading] = useState(false);

     // ✅ Show modal only if URL starts with /sbu/edit
     const showModal = location.pathname.startsWith('/religion/edit');

     const handleCloseModal = () => {
          navigate('/religion'); // Go back to list
     };

     // ✅ Fetch SBU details by ID
     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               fetch(`${baseUrl}/getReligionById/${id}`)
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) {
                              setReligionData(data.data);
                         } else {
                              setReligionData(null);
                         }
                         setLoading(false);
                    })
                    .catch(err => {
                         console.error('Error fetching SBU by ID:', err);
                         setLoading(false);
                    });
          }
     }, [id, showModal, baseUrl]);

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Religion Master</h2>
               </div>

               {/* Table of SBUs */}
               <ReligionTable />

               {/* Edit Modal */}
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Edit Religion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         {loading ? (
                              <div className="text-center">
                                   <Spinner animation="border" /> Loading...
                              </div>
                         ) : religionData ? (
                              <ReligionForm religionId={id} initialData={religionData} /> // ✅ Pass data to form
                         ) : (
                              <p className="text-center">No data found for this SBU.</p>
                         )}
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default ReligionEditModel;
